<template>
  <div class="p-seo__altitude">
    <div class="l-block__header">
      <TitleSub level="h3">
        <span class="title">スピード判定</span>
      </TitleSub>
    </div>
    <Loading v-if="isLoading" variant="inline" />
    <Error v-else-if="isError" variant="inline" size="sm">
      <template slot="title">
        データがありません。
      </template>
    </Error>
    <template v-else>
      <dl class="flex">
        <dt class="mobile">モバイル</dt>
        <dd>
          <DetailSpeedGraph :data="data.mobile" isAnimate />
        </dd>
      </dl>
      <dl class="flex">
        <dt class="desktop">デスクトップ</dt>
        <dd>
          <DetailSpeedGraph :data="data.desktop" isAnimate />
        </dd>
      </dl>
    </template>
  </div>
</template>

<script>
import DetailSpeedGraph from '@/components/seo/DetailSpeedGraph';
import Error from '@/components/Error';
import Loading from '@/components/Loading';
import TitleSub from '@/components/TitleSub';
import utils from '@/utils';

export default {
  props: ['data', 'isLoading'],

  components: {
    DetailSpeedGraph,
    Error,
    Loading,
    TitleSub
  },

  computed: {
    isError() {
      return (
        utils.isEmpty(this.data.mobile) && utils.isEmpty(this.data.desktop)
      );
    }
  }
};
</script>
